import { Button } from "@ttc3k/trekker";
import { useTranslation } from "react-i18next";
import {
  AnimatedPage,
  LoadingPage,
  PoweredByWhereabouts,
  StatusIndicator,
} from "shared/components";
import { handleBeaconClick } from "shared/utils";
import { Box, Center, Grid } from "styled-system/jsx";
import { PostOnboardingMessage } from "./components";
import { usePostOnboarding } from "./usePostOnboarding";
import { AnimatePresence } from "framer-motion";

export const PostOnboarding = () => {
  const { t } = useTranslation();

  const { screenCounter, welcomeMessage, handleNextClick } =
    usePostOnboarding();

  return !welcomeMessage ? (
    <LoadingPage />
  ) : (
    <Box
      bg={"bg.wa.light"}
      w={"100vw"}
      h={"full"}
      px={{ base: "400", md: "800" }}
      pb={"500"}
      pt={"1000"}
    >
      <Grid
        w={"full"}
        h={"full"}
        gridTemplateRows={"auto 1fr auto"}
        gridTemplateColumns={"1fr"}
        alignItems={"center"}
        justifyContent={"center"}
      >
        <Center
          justifySelf={"center"}
          opacity={screenCounter > 0 ? 1 : 0}
          transition={"opacity 400ms ease"}
        >
          <StatusIndicator
            label=""
            visual="accent.blue"
            numBoxes={4}
            numFilled={screenCounter}
          />
        </Center>

        <Center maxW="500px" justifySelf={"center"}>
          <AnimatePresence mode="wait">
            <AnimatedPage
              key={welcomeMessage.headingText}
              initial="enter"
              animationProps={{
                transition: {
                  duration: 0.45,
                  ease: "easeInOut",
                  type: "spring",
                },
              }}
            >
              <PostOnboardingMessage
                {...welcomeMessage}
                onClick={handleNextClick}
              />
            </AnimatedPage>
          </AnimatePresence>
        </Center>

        <Grid minW="full" w={"full"} alignItems={"center"}>
          <Box
            gridColumnStart={1}
            gridRowStart={1}
            justifySelf={{ base: "flex-start", md: "center" }}
          >
            <PoweredByWhereabouts />
          </Box>
          <Button
            size={"lg"}
            gridColumnStart={1}
            gridRowStart={1}
            justifySelf={"right"}
            visual={"success"}
            onClick={handleBeaconClick}
          >
            {t("core:SUPPORT")}
          </Button>
        </Grid>
      </Grid>
    </Box>
  );
};
